import { useState } from "react";

export function useLocalStorage<Type>(
  keyName: string,
  defaultValue: Type | null = null,
) {
  const [storedValue, setStoredValue] = useState<Type | null>(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      }
      if (!defaultValue) {
        return null;
      }
      window.localStorage.setItem(keyName, JSON.stringify(defaultValue));

      return defaultValue;
    } catch (err) {
      console.error("Error setting default local storage value:", err);
      return null;
    }
  });
  const setValue = (newValue: Type | null) => {
    try {
      if (newValue === null) {
        window.localStorage.removeItem(keyName);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(newValue));
      }
    } catch (err) {
      console.error("Error setting value for local storage: ", err);
    }
    setStoredValue(newValue);
  };
  return { storedValue, setValue };
}
